module.exports = __webpack_public_path__ + "static/media/How_your_diet_can_treat_diseases.e3e9d89f.jpg";